import { useProductType } from "app/hooks/shared/standard-product/useProductType";
import StandardProductConfig from "entities/shared/standard-product/config";
import { CategoryStandardProduct } from "shared/api/middleware-api-client";
import OptionConfigurationImage from "shared/ui/option-configuration-image";
import Heading from "shared/ui/typography/Heading";
import { concatClassnames } from "shared/utils/concatClassnames";

interface Props {
  standardProduct: CategoryStandardProduct;
  className?: string;
}

const SidebarStandardProductDescription = ({
  standardProduct,
  className,
}: Props) => {
  const type = useProductType(standardProduct);
  return (
    <div
      className={concatClassnames(
        "gg-flex gg-items-start",
        "gg-mb-6 md:gg-mb-10 lg:gg-mb-0",
        className,
      )}
    >
      <div
        className={concatClassnames(
          "gg-h-20 gg-w-20 gg-shrink-0 lg:gg-h-40 lg:gg-w-40",
          "gg-mr-7",
        )}
      >
        <OptionConfigurationImage
          imageId={standardProduct.thumbnailId || standardProduct.imageId}
        />
      </div>
      <div className={concatClassnames("gg-w-full")}>
        <Heading headingLevel="h2" className="gg-mb-3">
          {standardProduct.name},{" "}
          {standardProduct.amount * (type.isSet ? 2 : 1)} stuk
          {standardProduct.amount > 1 && "s"}
        </Heading>

        <StandardProductConfig standardProduct={standardProduct} />

        {/*{isNotAccesoire && (*/}
        {/*  <>*/}
        {/*    <hr className="2xl:gg-w-10/12" />*/}
        {/*    <StandardProductAvailability*/}
        {/*      className="gg-mt-3"*/}
        {/*      standardProduct={standardProduct}*/}
        {/*    />*/}
        {/*  </>*/}
        {/*)}*/}
      </div>
    </div>
  );
};
export default SidebarStandardProductDescription;
